// extracted by mini-css-extract-plugin
module.exports = {"title":"footerCollapsedTitle_title__2rYVz","arrow":"footerCollapsedTitle_arrow__3qEVX","reverseArrow":"footerCollapsedTitle_reverseArrow__1gmuW","content":"footerCollapsedTitle_content__2F8Ls","titleContent":"footerCollapsedTitle_titleContent__1EZ86","isColapsed":"footerCollapsedTitle_isColapsed__15j-m"};
    if(module.hot) {
      // 1747211657701
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  